'use strict';

import Component from 'generic.basecomponent';
import app from 'app-instance';

export default class HeroDonate extends Component {
    constructor(el) {
        super(el);
        this.elements = this.container.querySelectorAll(".js-hero-donate-item");
        this.currencyContainer = this.container.querySelector('.js-custom-donate-currency');
        this.init();
        app.addListener('donateAmount:input', this.removeActive.bind(this));
    }

    init() {
        [...this.elements].forEach(x => x.addEventListener("click", this.removeActive.bind(this)));
        [...this.elements].forEach(x => x.addEventListener("click", this.addActive.bind(this, x)));

        for (let i = 0; i < this.elements.length; i++) {
            this.elements[i].addEventListener('click', () => {
                document.getElementById("monthly-donation").style.cssText = "display: none";
                document.querySelector(".custom-donate__tab.js-button").classList.remove('js-active');
                document.querySelector(".custom-donate__tab.js-button.single-donate").classList.add('js-active');
                document.getElementById("single-donation").style.visibility = 'visible';
                document.getElementById("single-donation").style.cssText = "display: block";
                document.querySelector(".js-custom-donate-currency").style.visibility = 'visible';
            });
        }
    }

    removeActive() {
        [...this.elements].forEach(x => x.classList.remove("is-active"));
        this.container.classList.remove("is-some-active");
    }

    addActive(element) {
        this.container.classList.add("is-some-active");
        element.classList.add("is-active");
        app.emitEvent('donateAmount:change', [element.dataset.amount])
    }
}

HeroDonate.id = 0;



// WEBPACK FOOTER //
// ./app/components/hero-donate/js/generic.hero-donate.js